import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';
import {Stack, Card, CardHeader, CardActions, Avatar, Button, Grid, Typography, Box} from 'views/components';
import {PhoneOutlined} from 'views/icons';
import {Translate, translate} from 'views/module';

import buildBlakeCalendlyLink from '../../utils/blakeCalendlyLink';

const CareTeamSection = (props) => {
  const {user, clientData} = props;

  const buttonHref = React.useMemo(() => {
    return buildBlakeCalendlyLink({user, clientData});
  },
  [
    user?.userRn,
    user?.email,
    user?.firstName,
    user?.lastName,
    clientData?.clientDetail?.relationships?.[user?.userRn]?.contacts,
  ],
  );

  const careTeam = [
    {
      name: 'Daniel C.',
      jobTitle: translate('dashboard.sections.careTeam.jobTitles.careConsultant'),
      avatar: '/images/daniel_avatar.jpeg',
      buttonText: translate('dashboard.sections.careTeam.buttons.bookCall'),
      buttonIcon: <PhoneOutlined />,
      buttonHref,
    },
  ];

  return (
    <Stack spacing={2} id="care-team">
      <Stack spacing={1}>
        <Typography
          variant="h5"
        >
          <Translate expression={'dashboard.sections.careTeam.title'} />
        </Typography>
        <Typography
          variant="body2"
        >
          <Translate expression={'dashboard.sections.careTeam.subtitle'} />
        </Typography>
      </Stack>
      <Box>
        <Grid container spacing={2}>
          {careTeam.map((member) => {
            return (
              <Grid key={member.name} xs={12} md={6} lg={4} item>
                <Card
                  sx={
                    member.isPlaceholder ?
                      {
                        backgroundColor: 'transparent',
                        border: 'dashed 1px',
                        borderColor: 'grey.400',
                      } : null
                  }
                >
                  <CardHeader
                    avatar={
                      <Avatar
                        src={member.avatar}
                        alt={member.name}
                        sx={{
                          backgroundColor: 'transparent',
                          color: 'grey.400',
                          border: '1px solid',
                          borderColor: 'grey.400',
                        }}
                      />
                    }
                    title={member.name}
                    subheader={member.jobTitle}
                  />
                  <CardActions>
                    <Button
                      variant='outlined'
                      fullWidth
                      startIcon={member.buttonIcon}
                      onClick={() => window.open(member.buttonHref, '_blank', 'noopener,noreferrer')}
                      disabled={member.isPlaceholder}
                    >
                      {member.buttonText}
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Stack>
  );
};

CareTeamSection.propTypes = {
  user: PropTypes.object.isRequired,
  clientData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
  clientData: state.clientData,
});

export default connect(mapStateToProps, dispatch)(CareTeamSection);
